import actionTypes from "constants/chat";
import { Action, ActionFunctionAny, createActions } from "redux-actions";

const { READ_ALL_CHATS, READ_CHAT, TOGGLE_FAVORITE_CHAT } = actionTypes;

const actions = createActions(READ_ALL_CHATS, READ_CHAT, TOGGLE_FAVORITE_CHAT);

const readAllChats = () => (dispatch: ActionFunctionAny<Action<Object>>) => dispatch(actions.readAllChats());

const readChat = (params: {}) => (dispatch: ActionFunctionAny<Action<Object>>) => dispatch(actions.readChat(params));

const toggleFavorite = (params: {}) => (dispatch: ActionFunctionAny<Action<Object>>) =>
    dispatch(actions.toggleFavoriteChat(params));

export default { ...actions, readAllChats, readChat, toggleFavorite };
